import type React from 'react';

import { Tip } from '@change/ds-core-ui';
import { RaisedFistIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core-react/i18n';

/**
 * The motivation callout (psf_share_motivation_layer_top_8_experiment, variant arm): a boxed commitment
 * line rendered between the Copy-link divider and the share-channel grid. Purely presentational —
 * the wrapper (`ShareSlideUp/index.tsx`) owns all experiment/suppression logic.
 *
 * Tip's default small rendering diverges from the approved callout visual (icon stacked above the
 * text below `md`, blue circular icon badge, information-blue container). The class overrides below
 * are the plan's pre-authorized adjustment lane — DS tokens/utilities through Tip's documented
 * `className`/`containerClassName` props:
 * - root: neutral raised background + 12px radius + 14px padding (nearest tokens to the spec's
 *   #f6f7fa / 14px / 13-15px; the default `border-stroke-weaker` border already matches)
 * - container: always a single row with icon + text vertically centered (Tip defaults to
 *   column below `md` and `items-start`; both are overridden here)
 * - icon span (`[&>span]`, no dedicated prop): drop the badge fill for a plain 24px glyph in the
 *   default icon color; `self-center` beats Tip's `md:self-start`; text gets weight 500 by
 *   targeting the `data-variant="body"` attribute Tip renders its copy text with internally —
 *   no dedicated prop for this either
 */
export const MotivationCallout: React.FC<EmptyProps> = () => (
	<div className="mb-4" data-testid="petition-share-slide-up-motivation-callout">
		<Tip
			className="bg-background-raised rounded-lg p-3.5"
			containerClassName="flex-row items-center [&>span]:size-6 [&>span]:shrink-0 [&>span]:self-center [&>span]:bg-fill-transparent [&>span]:text-icon-strong [&_[data-variant='body']]:font-medium"
			icon={<RaisedFistIcon size="medium" />}
			size="small"
		>
			<Translate value="corgi.psf.promote_or_share.share_slide_up.commitment_nudge" />
		</Tip>
	</div>
);
